import config from './config'
import moment from 'moment'
import 'moment-timezone'

export const contentTimezone: string = config.contentTimezone

export const contentTimezoneOffset: string = moment().tz(contentTimezone).format('Z')

export const offsetToContentTimezone = (originalDate: Date | string | number): Date => {
  const contentOffset = moment().tz(contentTimezone).utcOffset()
  const localOffset = moment().utcOffset()

  const date = moment(originalDate)

  if (localOffset !== contentOffset) {
    const offsetDiff = localOffset - contentOffset
    date.subtract(offsetDiff, 'minutes')
  }

  return date.toDate()
}
